import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import { Box, Button, Stack } from '@mui/material';
import { MIcon } from '../@material-extend';

import { startPreview, stopPreview, flipCamera, takePicture } from '../../utils/camera';

const ImagePreviewModal = ({ open, onClose, onPicture }) => {
  const [started, setStarted] = useState(true);

  useEffect(() => {
    if (window.env.isAndroid) {
      if (started && window.screen) {
        startPreview();
      } else if (window.screen && !started) {
        stopPreview();
      }
    }
  }, [started]);

  useEffect(() => {
    setStarted(open);
  }, [open]);

  if (!started) {
    return;
  }

  const handleClickCamera = () =>
    takePicture().then((image) => {
      onPicture(image);
      setStarted(false);
      stopPreview();
      onClose();
    });

  const handleClickFlip = () => {
    flipCamera();
  };

  const handleClickClose = () => {
    stopPreview();
    onClose();
  };

  const styleContainer = {
    position: 'absolute',
    top: 0,
    display: open ? 'flex' : 'none',
    width: '100%',
    height: '100%',
    minWidth: '100%',
    minHeight: '100%',
    bgcolor: 'background.paper',
    zIndex: open ? 999999 : -10000
  };

  const styleIcon = { fontSize: 30 };

  return ReactDOM.createPortal(
    <Stack direction="column" sx={styleContainer}>
      <Box
        id="previewPhoto"
        sx={{
          width: '100%',
          height: 'calc(100% - env(safe-area-inset-bottom) - env(safe-area-inset-top))',
          background: 'transparent'
        }}
      />

      <Stack direction="row" justifyContent="space-around">
        <Button size="large" onClick={handleClickClose}>
          <MIcon icon="close" sx={styleIcon} />
        </Button>
        <Button size="large" onClick={handleClickCamera}>
          <MIcon icon="camera_alt" filled sx={styleIcon} />
        </Button>
        <Button size="large" onClick={handleClickFlip}>
          <MIcon icon="flip_camera_android" filled sx={styleIcon} />
        </Button>
      </Stack>
    </Stack>,
    document.getElementById('root')
  );
};

ImagePreviewModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onPicture: PropTypes.func
};

export default ImagePreviewModal;
